export enum ApportionmentChartOfAccountType {
    EXPENSE = 'Expense',
    INCOME = 'Income',
    TRANSFER = 'Transfer'
}
